// Chakra imports
import { Box, Flex, Text, useColorModeValue } from '@chakra-ui/react';
// Assets
import { HSeparator } from 'components/separator/Separator';
// Custom components
import ReceiptTable from 'views/admin/main/ecommerce/orderDetails/components/ReceiptTable';
// Ya NO importamos tableDataReceipt porque lo recibimos por props

// Asegúrate de que props incluya tableData
export default function Content(props: { tableData: any[]; [x: string]: any }) {
	const { tableData, ...rest } = props;

	// Chakra Color Mode
	const textColor = useColorModeValue('secondaryGray.900', 'white');

	// Calcular total en tiempo real basado en props.tableData
	const total = tableData.reduce((acc, item) => acc + (Number(item.amount) || 0), 0);
	const paid = 0;

	return (
		<Flex direction='column' p={{ base: '20px', md: '34px' }} px={{ base: '0px', md: '34px' }} {...rest}>
			<ReceiptTable tableData={tableData} />
			{/* <Flex mt='70px' direction={{ base: 'column', md: 'row' }}>
				<Box me='auto' mb={{ base: '40px', lg: '0px' }}>
					<Text fontSize='lg' fontWeight='700' color={textColor}>
						Notas
					</Text>
					<Text fontSize='md' fontWeight='400' color='secondaryGray.600' maxW='322px'>
						Envía todos los activos juntos y te enviaré un correo electrónico, por favor verifica. ¡Gracias!
					</Text>
				</Box>
				<Box>
					<Flex align='center' justifyContent='space-between' mb='12px'>
						<Text textAlign='end' color={textColor} fontSize='lg' fontWeight='400'>
							Total
						</Text>
						<Text color={textColor} fontSize='lg' fontWeight='700' maxW='292px'>
							${total.toFixed(2)}
						</Text>
					</Flex>
					<Flex align='center' justifyContent='space-between'>
						<Text me='70px' fontWeight='400' textAlign='end' color={textColor} fontSize='lg'>
							Pagado hasta la fecha
						</Text>
						<Text color={textColor} fontSize='lg' fontWeight='700' maxW='292px'>
							${paid.toFixed(2)}
						</Text>
					</Flex>
					<HSeparator my='20px' />
					<Flex direction='column' gap='20px'>
						<Flex align='center' justifyContent='space-between'>
							<Text fontWeight='400' color={textColor} fontSize='lg'>
								Monto a pagar
							</Text>
							<Text color={textColor} fontSize='lg' fontWeight='700' w='292px' textAlign='right'>
								${(total - paid).toFixed(2)}
							</Text>
						</Flex>
					</Flex>
				</Box>
			</Flex> */}
		</Flex>
	);
}
